module.exports = __webpack_public_path__ + "static/media/2020 - 21 Alex Lau.91cb2e90.jpg";